import { backendService } from "../../services";
import { fromSnakeToCamel } from "../shared/utils";

const BASE = "player-api/game/topik";

const post = async (path, data = {}) => {
  const response = await backendService.post({ url: `${BASE}/${path}`, data });
  return { data: fromSnakeToCamel(response.data) };
};

export const session = {
  get: async () => {
    const response = await backendService.get({ url: `${BASE}/session` });
    return { data: fromSnakeToCamel(response.data) };
  },
};

export const comparisons = {
  generality: ({ comparisonId, cardId }) => (
    post("comparisons/generality", { comparison_id: comparisonId, card_id: cardId })
  ),
  outcome: ({ comparisonId, cardId }) => (
    post("comparisons/outcome", { comparison_id: comparisonId, card_id: cardId })
  ),
};

export const analysis = {
  observation: ({ observation }) => post("analysis/observation", { observation }),
  seriousness: ({ seriousness }) => post("analysis/seriousness", { seriousness }),
  issues: ({ issues }) => post("analysis/issues", { issues }),
  risk: ({ risk }) => post("analysis/risk", { risk }),
  solution: ({ solution }) => post("analysis/solution", { solution }),
  continue: ({ continue: shouldContinue }) => (
    post("analysis/continue", { continue: shouldContinue })
  ),
  riskMitigation: ({ riskMitigation }) => (
    post("analysis/risk-mitigation", { risk_mitigation: riskMitigation })
  ),
  solutionMaximizer: ({ solutionMaximizer }) => (
    post("analysis/solution-maximizer", { solution_maximizer: solutionMaximizer })
  ),
  goal: ({ goal, goalCapability, goalWill }) => (
    post("analysis/goal", {
      goal,
      goal_capability: goalCapability,
      goal_will: goalWill,
    })
  ),
  back: () => post("analysis/back"),
};

// Graduated AI step companion (§6.5). `request` queues an inference for the step's next
// ladder level (202) and `poll` reads {status, kind, text, suggestions, question, used, cap}.
// Step ids travel snake_cased on the wire; the client addresses steps in camelCase.
const snakeStep = (step) => step.replace(/[A-Z]/g, (c) => `_${c.toLowerCase()}`);

export const aiAssist = {
  request: ({ step, draft }) => post("ai-assist", { step: snakeStep(step), draft }),
  poll: async ({ step }) => {
    const response = await backendService.get({ url: `${BASE}/ai-assist?step=${snakeStep(step)}` });
    return { data: fromSnakeToCamel(response.data) };
  },
};
